package org.moxultimate.topwithmox.core.base

object BaseAPI {
    const val production = true
    val baseAPI = if (production) {
        "https://api.topwithmox.com"
    } else {
        "http://localhost:9090"
    }

}